
export const TempUtils = {
  /**
   }
   * 摄氏度 转 华氏度
   * @param {number} celsius
   * @returns {number}
   */
  celsiusToFahrenheit (celsius) {
    celsius = Number(celsius);
    let val = (celsius * 9) / 5 + 32;
    return Number(val.toFixed(2));
  },

  /**
   * 摄氏度 转 开尔文
   * @param {number} celsius
   * @returns {number}
   */
  celsiusToKelvin (celsius) {
    celsius = Number(celsius);
    let val = celsius + 273.15;
    return Number(val.toFixed(2));
  },

  /**
   * 华氏度 转 摄氏度
   * @param {number} fahrenheit
   * @returns {number}
   */
  fahrenheitToCelsius (fahrenheit) {
    const celsius = ((Number(fahrenheit) - 32) * 5) / 9;
    return celsius.toFixed(2);
  },

  /**
   * 开尔文 转 摄氏度
   * @param {number} kelvin
   * @returns {number}
   */
  kelvinToCelsius (kelvin) {
    kelvin = Number(kelvin);
    return (kelvin - 273.15).toFixed(2);
  },
  /**
   * 通用转换方法
   * @param {number} value 温度值
   * @param {string} toUnit 目标单位 ('C', 'F', 'K')
   * @returns {number} 转换后的值
   */
  convertFormCelsius(value, unit) {
    if (unit === '°C') return value;
    switch (unit) {
      case "°F":
        return this.fahrenheitToCelsius(value);
      case "K":
        return this.kelvinToCelsius(value);
      case "°C":
      default:
        return value;
    }
  },
  /**
   * 通用转换方法
   * @param {number} value 温度值
   * @param {string} toUnit 目标单位 ('C', 'F', 'K')
   * @returns {number} 转换后的值
   */
  convertToCelsius(value, unit) {
    if (unit === '°C') {
      return value;
    }
    switch (unit) {
      case "°F":
        return this.celsiusToFahrenheit(value);
      case "K":
        return this.celsiusToKelvin(value);
      case "°C":
      default:
        return value;
    }
  },
}
